import { render, staticRenderFns } from "./CardQuicklink.vue?vue&type=template&id=2983cc8d&scoped=true"
import script from "./CardQuicklink.vue?vue&type=script&lang=ts"
export * from "./CardQuicklink.vue?vue&type=script&lang=ts"
import style0 from "./CardQuicklink.vue?vue&type=style&index=0&id=2983cc8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2983cc8d",
  null
  
)

export default component.exports